'use client';

// NOTE: THis used to be a SSR component, but since we now need a way
// to redirect to [other-locale]/[current-path], and next for some reason
// refuses to support getting a pathname on the server,
//
// So its a client component now. again.
//
// ...
// ...
// I sometimes wonder if we should've just used Wix instead.

import { env } from '@/constant/env';
import LinkButton from '@/components/atoms/LinkButton';
import { Region } from '@/features/Header/constants/regions';
import { cn } from '@/lib/utils';
import useLocaleEntry from './useLocaleEntry';

type Props = { region: Region };

const LocleEntry = ({ region }: Props) => {
  const { redirectHref } = useLocaleEntry({ region });
  const isActive = region.locale === env.publicLocale;

  return (
    <LinkButton
      classNames={{
        root: cn(
          'px-0 h-6 focus-visible:outline-none focus-visible:underline focus-visible:decoration-inherit',
          isActive && 'pointer-events-none'
        ),
        inner: isActive ? '' : 'dark',
      }}
      openInNewTab={false}
      variant='text'
      color={isActive ? 'primary' : 'secondary'}
      href={redirectHref}
    >
      {region.title}
    </LinkButton>
  );
};

export default LocleEntry;
